import React from "react"
import { FormattedDate, FormattedMessage, injectIntl } from "react-intl"
import Icon from "../../common/icon/icon.component"
import { ImportInfoProps } from "../../common/types/inventory"
import ImportStatus from "./Status"


const ImportDetailsInfo = (props: ImportInfoProps) => {
    const renderFieldColumn = (colClass, labelFormattedMessage, value) => {
        return <div className={"position-relative mt-2 px-1 text-break " + colClass}>
            <div className={"py-1 px-2 h-100 inline-input"}>
                {labelFormattedMessage ?
                    <div>
                        <label className="col-form-label custom-form-label project-details-label pt-0">
                            {labelFormattedMessage}
                        </label>
                    </div> : ""
                }
                <div>
                    {value}
                </div>
            </div>
        </div>
    }

    return (
        <>
            <div className={"row ui-module"}>
                <div className={"col-lg-6 col-md-12 pl-md-3 pr-md-0 pr-lg-3 "} >
                    <div className={"row mb-md-3"}>
                        <div className="col-12 pl-0 pr-md-0 pl-lg-1">
                            <h3 className={"m-0 d-flex align-items-center"}>
                                < FormattedMessage
                                    id="payment.analytics.title_label"
                                    defaultMessage="Import {importIdentifier}"
                                    values={{
                                        importIdentifier : props.import?.attributes.identifier
                                    }}
                                />
                                <h6 className="ml-2 d-inline mb-0">
                                    <ImportStatus
                                        status={props.import?.attributes.status || ""}
                                        className={""}
                                    />
                                </h6>
                            </h3>
                        </div>
                        {renderFieldColumn("col-lg-3 col-md-4", <FormattedMessage
                            id="listing.product.import.list.headers.created_at_label"
                        />, <FormattedDate
                            id="listing.product.import.list.headers.created_at_label"
                            value={props.import?.attributes.createdAt}
                            year='numeric'
                            month='long'
                            day='numeric'
                        />
                        )}
                        {renderFieldColumn("col-lg-3 col-md-4", <FormattedMessage
                            id="listing.product.import.list.headers.csv_file_name"
                            defaultMessage="Csv File"
                        />,  <a href={props.import?.attributes.fileUrl} target="_blank" rel="noreferrer" >
                            <p className="p-0 m-0">{props.import?.attributes.fileName}</p>
                        </a>
                        )}
                        {renderFieldColumn("col-lg-6 col-md-8", <FormattedMessage
                            id="invoice.credit_memo_modal.notes_label"
                        />, props.import.attributes.notes
                        )}
                    </div>
                    <div className={"row mb-md-3"}>
                        <div className="col-3 pl-0 pr-md-0 pl-lg-1">
                            
                        </div>
                    </div>
                </div>
                < div className={"col-lg-4 col-md-12 pl-md-3 pr-md-0 pr-lg-3"} />
                <div className={"col-lg-2 col-md-12 pl-md-3 pr-md-0 pr-lg-3"} >
                    <div className={"w-100"}>
                        <label className="col-form-label custom-form-label project-details-label pt-2">
                            <strong>
                                <FormattedMessage
                                    id="quote.analytics.inventory_location_label"
                                    defaultMessage="Inventory Location"
                                />
                            </strong>
                        </label>
                    
                        <p className={"m-0 position-relative"}>
                            <Icon value={"map-marker-alt"} />
                            {props.import?.attributes.inventoryLocation?.attributes.name}
                        </p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default injectIntl(ImportDetailsInfo)


// WEBPACK FOOTER //
// ./src/product/import/ImportInfoPage.tsx